import { useCallback, useEffect, useState } from 'react';

/** 一度閉じたら以降は案内しないためのフラグ */
const DISMISSED_KEY = 'clinicten.englishSiteGuideDismissed';

/**
 * ブラウザの言語設定に日本語が含まれるか。
 * 日本語が第一言語でなくとも候補に含まれていれば日本語の予約画面を読めるとみなす。
 */
const prefersJapanese = () => {
  const languages = navigator.languages?.length ? navigator.languages : [navigator.language];
  return languages.some(language => language?.toLowerCase().startsWith('ja'));
};

/** プライベートブラウズ等でストレージが使えない場合は「未案内」として扱う */
const isDismissed = () => {
  try {
    return !!localStorage.getItem(DISMISSED_KEY);
  } catch {
    return false;
  }
};

const dismiss = () => {
  try {
    localStorage.setItem(DISMISSED_KEY, '1');
  } catch {
    // 保存できなくても案内の抑止ができないだけなので握りつぶす
  }
};

/**
 * 日本語以外のブラウザで予約画面を開いた場合に、英語ページへの導線を一度だけ案内する。
 */
export const useEnglishSiteGuide = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // ?lang=en は英語話者向けの導線を通ってきた場合に付与されるため、重ねて案内しない
    const fromEnglishFlow = new URLSearchParams(window.location.search).get('lang') === 'en';
    if (prefersJapanese() || fromEnglishFlow || isDismissed()) {
      return;
    }
    setVisible(true);
  }, []);

  const close = useCallback(() => {
    dismiss();
    setVisible(false);
  }, []);

  return { visible, close };
};
